import { Spinner } from '../../components';
import { ResultsCardFrame } from '../results/ResultsCardFrame';
import type { ResultSession } from '../results/sessions';
import { useResultSessionStore } from '../results/store';
import type { BoardContextValue } from '../useBoardContext';
import { ExamDetailTab } from './ExamDetailTab';
import { ExamStatsTab } from './ExamStatsTab';
import { examDisplayTitle } from './examResults';
import { useExamResultStore } from './store';
import { useClassExamLoad, useExamResultsView } from './useExamResults';

export interface ExamResultsCardProps {
  session: ResultSession;
  context: BoardContextValue;
  onClose: () => void;
  onBackToDe: () => void;
}

// Real class results for the exam on this tab. The board is projected, so names, scores and who has
// not submitted wait behind Hiện điểm; Thống kê is anonymous and always shows.
export function ExamResultsCard({ session, context, onClose, onBackToDe }: ExamResultsCardProps) {
  const examId = session.refId;
  useClassExamLoad(context);
  const { view, exam, results, questionsLoading, questionsError, retryQuestions } = useExamResultsView(examId);
  const titles = useExamResultStore((state) => state.courseTitles);
  const examTitles = useExamResultStore((state) => state.examTitles);
  const setPanelTab = useResultSessionStore((state) => state.setPanelTab);
  const setShowScores = useResultSessionStore((state) => state.setShowScores);
  const openStudent = useResultSessionStore((state) => state.openStudent);

  const subtitle = exam ? [examDisplayTitle(exam, examTitles), titles[exam.courseId] || ''].filter(Boolean).join(' • ') : session.title;
  const questionNote = questionsLoading ? <Spinner size="small" label="Đang tải câu hỏi…" /> : questionsError
    ? <p className="quiz-results__empty">Chưa tải được câu hỏi: {questionsError} <button type="button" className="hw-panel__refresh" onClick={retryQuestions}>Thử lại</button></p>
    : null;
  const actions = (
    <>
      <button type="button" className="hw-panel__refresh" aria-pressed={session.showScores} onClick={() => setShowScores(session.tabId, !session.showScores)}>{session.showScores ? 'Ẩn điểm' : 'Hiện điểm'}</button>
      {session.student ? <button type="button" className="hw-panel__refresh" onClick={onBackToDe}>Quay lại đề</button> : null}
    </>
  );

  return (
    <ResultsCardFrame label="Kết quả bài kiểm tra" subtitle={subtitle} actions={actions} tab={session.panelTab} onTab={(tab) => setPanelTab(session.tabId, tab)} onClose={onClose}>
      {!results ? (view.kind === 'error' ? <p className="quiz-results__empty">Chưa tải được kết quả: {view.message}</p> : <Spinner label="Đang tải kết quả của lớp…" />)
        : session.panelTab === 'stats' ? <ExamStatsTab results={results} questionNote={questionNote} />
          : <ExamDetailTab results={results} showScores={session.showScores} activeCode={session.student} onOpenStudent={(code) => openStudent(session.tabId, code)} />}
    </ResultsCardFrame>
  );
}
